import React, { useEffect } from "react";
import { Route, Switch } from 'react-router';
import NavMenu from './common/NavMenu';
import { connect } from "react-redux";
import { setupNavigation } from "../redux/actions/navItemsActions";
import PropTypes from "prop-types";
import "./Home.css";
import { Helmet } from 'react-helmet';

function About({ setupNavigation }) {

    const navigationItems =
    {
        sections: [{
            name: 'Admin',
            items: [
                {
                    path: '/about',
                    text: 'About JustGoRide',
                    icon: 'fas fa-info-circle'
                },
                {
                    path: '/about/contact',
                    text: 'Contact',
                    icon: 'far fa-at'
                },
                {
                    path: '/about/termsandconditions',
                    text: 'Terms and Conditions',
                    icon: 'fas fa-file-signature'
                },
                {
                    path: '/about/privacypolicy',
                    text: 'Privacy Policy',
                    icon: 'fas fa-user-secret'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "Terms and Conditions | JustGoRide";
        setupNavigation(navigationItems);

    }, []);

    return (
        <div className="policy row justify-content-center my-4">
            <Helmet>
                <meta name="title" content="Discover GPX Cycle Route Sharing | JustGoRide" />
                <meta name="description" content="Search, Create and Ride great new new cycle routes by learning about how to make the most of the free GPS mapping tools and GPX cycle route resources on offer from JustGoRide. Whether you ride mountain bikes, road bikes or unicycles, JustGoRide is the first place to go if you want to explore the great outdoors on your bike!" />
                <meta name="keywords" content="global gpx route sharing, download gpx route files, upload gpx route files, create gpx route files, search gpx route file catalog, bike rides and routes in gpx format" />
            </Helmet>
            <div className="col-10">
                <img className="about-logo" alt="JustGoRide" src="/resources/images/new-email-logo.png" />
                <p>
                    Founded back in 2009 JustGoRide was initially built as a personal route plotting tool to facilitate the creation of GPX route files. Frustrated
                    by the lack of routes available online at the time, I had the idea to build up an online catalogue of routes so that others could create and share
                    routes in their local area. In 2010 the first version of JustGoRide was launched. Over the years JustGoRide has evolved and grown into a valuable
                    resource for the dedicated global community of riders who have contributed to what has become a rich and varied database of cycling routes.
                </p>
                <p>
                    Creating routes has always been at the centre of what drives JustGoRide and as my experiences with cycling have developed over the years, first with
                    mountain biking, leading to road riding and racing and more recently gravel riding, it has become clear that JustGoRide could develop into a much more
                    rounded resource for cyclists. Spurred on by joining my local cycling club, I soon realised that the social element of cycling was the final piece in the
                    puzzle, but a very important one.
                </p>
                <p>
                    By still having the route at the heart of the website it made sense to then bring riders together to share the experience of riding those routes. To plan
                    an event around a ride, a trip or even the challenge of a lifetime, however your riding has evolved, where you ride and who you ride with shapes
                    the experiences that you have on a bike.
                </p>
                <p>
                    JustGoRide is not just another online social network… far from it. Online social networks are about sitting in front of a computer, anonymously bashing a
                    keyboard. JustGoRide has evolved to encourage a real-life social network where we can get together in person, saddle up and hit the trail. JustGoRide is here
                    to help you organise your riding to make sure that you and your riding network are able to spend less time trying to sort out your next adventure and more
                    time riding it. Whether you're in a club or just a group of mates who ride at the weekend, JustGoRide is for you. Create your Group, invite your friends, plan
                    some routes and then organise some rides. Simple.
                </p>
                <p>
                    A new version of JustGoRide has recently been launched, built from the ground up to be the foundation of the best cycling technology platform possible.
                    There are more improvements planned with a mobile app in the works and a project in the pipeline to build an activity logging feature focused around routes.
                    The basis of JustGoRide will always be, as it always has been, a free resource. In the future there will be some additional features which will form part of
                    a premium offering as servers will always have to be paid for, but rest assured the routes at the heart of this site will remain yours.
                </p>
                <p>Ride Social.</p>
                <p>
                    Pete
                    <br/>
                    <span className="text-muted">Founder JustGoRide</span>
                </p>
            </div>
        </div>
    );
}

About.propTypes = {
    setupNavigation: PropTypes.func.isRequired
}


function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(About);   


// WEBPACK FOOTER //
// ./src/components/About.js